import * as React from 'react';
import Button from '@mui/material/Button';
import { marked } from 'marked';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useLocation, useNavigate } from "react-router-dom";
import SaveIcon from "@mui/icons-material/SaveOutlined";

import DownloadButtons from "./downloadButton";
import { downloadFile } from "./api";

export default function NextButton(props) {
     const [anchorEl, setAnchorEl] = React.useState(null);
     const navigate = useNavigate();

     const handleClick = (event) => {
          if (props.document_name && props.document_name !== "") {
               handleNext();
          } else {
               setAnchorEl(event.currentTarget);
          }
     };

     const handleClose = () => {
          setAnchorEl(null);
     };
     const handleNext = () => {
          const section = props.getNextStep(props.section)
          navigate(`/upload?project_name=${props.project_name}&section=${section}`)
     }
     const open = Boolean(anchorEl);
     const id = open ? 'simple-popover' : undefined;
     const style = {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'auto',
          bgcolor: 'background.paper',
          borderRadius: '2px ',
          boxShadow: 24,
          p: 4,
     };

     return (
          <div>
               <Button sx={{ textTransform: 'capitalize', fontSize: '1rem' }}
                    disabled={!props.download_text || props.value.section == "Expected_results" || props.user_edit || props.loading || props.covloader}
                    variant="contained"
                    // startIcon={<FileDownloadIcon />}
                    onClick={handleClick} >
                    Next
               </Button>
               <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
               >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center', marginTop: '50px' }}>
                         <Box sx={style}>

                              <FormControl variant="outlined" style={{ minWidth: 200, display: 'flex' }}>
                                   <div id="file-type-label">Please make sure you have saved the generated document.</div>
                              </FormControl>
                              <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', alignItems: 'center', marginTop: '50px' }}>
                                   <Button
                                        sx={{ textTransform: 'capitalize', fontSize: '1rem' }}
                                        // disabled={!download_text || user_edit || loading || covloader}
                                        startIcon={<SaveIcon />}
                                        variant='contained'
                                        onClick={() => props.handleSave1()}
                                   >
                                        Save to dashboard
                                   </Button>
                                   {/* <DownloadButtons download_text={props.download_text} value={props.value} handleNextClose={handleClose} handleNext={handleNext} /> */}
                                   <Button sx={{ textTransform: 'capitalize', fontSize: '1rem' }} variant="contained" color="primary" onClick={handleNext}>
                                        Proceed without save
                                   </Button>
                              </div>
                         </Box>
                    </div>
               </Modal>
          </div>
     );
}
